<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Data table -->
      <v-card>
        <v-card-title>
          <v-row>
              <v-col cols="12" md="4" sm="12">
                  <v-btn rounded class="mr-5" depressed color="primary" @click="handleAdd()">
                      <v-icon class="mr-1"> mdi-plus-circle </v-icon>
                      {{ $t("addNew") }}
                  </v-btn>
              </v-col>

              <v-col cols="6" md="2" sm="6">
                  <v-menu
                      v-model="menuDateFrom"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                  >
                      <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                              v-model="from_date"
                              :label="$t('dateFrom')"
                              prepend-inner-icon="mdi-calendar"
                              outlined
                              dense
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              clearable
                          ></v-text-field>
                      </template>
                      <v-date-picker
                          :first-day-of-week="0"
                          v-model="from_date"
                          @input="menuDateFrom = false"
                      ></v-date-picker>
                  </v-menu>
              </v-col>

              <v-col cols="6" md="2" sm="6">

                  <v-menu
                      v-model="menuDateTo"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                  >
                      <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                              v-model="to_date"
                              :label="$t('dateTo')"
                              prepend-inner-icon="mdi-calendar"
                              outlined
                              dense
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              clearable
                          ></v-text-field>
                      </template>
                      <v-date-picker
                          :first-day-of-week="0"
                          v-model="to_date"
                          @input="menuDateTo = false"
                      ></v-date-picker>
                  </v-menu>
              </v-col>

              <v-col cols="6" md="2" sm="6">
                  <v-text-field
                      v-model="search"
                      :label="$t('search')"
                      single-line
                      outlined
                      dense
                      clearable
                  >
                  </v-text-field>
              </v-col>

                <v-col cols="12" md="2" sm="12">
                  <v-btn class="mr-6" dark color="blue-grey" elevation="2" outlined text @click="handleSearch()">
                      <v-icon class="mr-1"> mdi-magnify </v-icon>
                  </v-btn>

                   <v-btn @click="exportExcel('exportExcel')" outlined>
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="26" height="26" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#000000"><path d="M24.08,6.88v158.24h104.22125l-5.85203,-6.88h-91.48922v-144.48h65.36v44.66625h44.72v41.33375h6.88v-46.09735l-0.88015,-0.88015c-0.12384,-0.15136 -0.26193,-0.28928 -0.40985,-0.41656l-45.49265,-45.48594zM103.2,18.57734l32.9689,33.02266h-32.9689zM58.97719,65.36l18.12047,30.96l-19.78,30.96h16.56844l10.77015,-19.98156c0.74992,-1.92984 1.23813,-3.40447 1.44453,-4.34703h0.1075c0.42656,2.01928 0.84393,3.38883 1.24297,4.13875l10.76344,20.19656h16.46766l-19.05438,-31.27578l18.53703,-30.65094h-15.53375l-9.83625,18.32875c-0.946,2.39424 -1.61772,4.28522 -1.9686,5.48922h-0.10078c-0.54352,-2.01928 -1.16949,-3.81894 -1.86781,-5.28094l-8.90235,-18.53703zM130.72,106.64v30.96h-17.2l29.22656,34.4l29.25344,-34.4h-17.2v-30.96zM137.6,113.52h10.32v30.96h8.94265l-14.11609,17.2l-14.08922,-17.2h8.94265z"></path></g></g></svg>
                    </v-btn>
              </v-col>
          </v-row>
        </v-card-title>

        <v-data-table
            id="exportExcel"
            :loading="loading"
            :headers="headers"
            :items="transactionProductOrderList"
            :search="search"
            hide-default-footer
            class="elevation-1"
            :server-items-length="totalPage"
            :items-per-page="itemsPerPage"
            :page.sync="currentPage"
            :options.sync="options"
            :mobile-breakpoint="0"
        >
          <!-- Progressive -->
          <template v-slot:progress class="text-center"><v-progress-circular indeterminate color="green" :value="50"></v-progress-circular></template>

          <!-- Header -->
          <template v-slot:header.date="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.expected_date="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.reference="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.client_name="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.supplier_name="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.total_amount="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.status="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.action="{ header }">{{ $t(header.text) }}</template>

          <!-- Body -->
          <template v-slot:item.date="{ item }">{{ item.date | dateFormat}}</template>
          <template v-slot:item.total_amount="{ item }">{{ parseFloat(item.total_amount) | formatNumber }}{{ getCurrencySymbol(item.currency_code) }}</template>
          <template v-slot:item.status="{ item }"><v-chip small outlined :color="getColor(item.status)" dark> {{$t(item.status) }}</v-chip></template>

          <!-- Action -->
          <template v-slot:item.action="{ item }">
            <v-btn color="primary" outlined class="table-action-button mr-2" text icon @click="handleEdit(item,$event)" :disabled="item.status!=='order'"><font-awesome-icon icon="edit"/></v-btn>
            <v-btn color="error" outlined class="table-action-button" text icon :disabled="item.status!=='order'" @click.native="handleRemove(item)"> <font-awesome-icon icon="trash"/></v-btn>
            <!--<v-btn color="success" outlined class="table-action-button" text icon :to="{ name: 'po-form', params: { id: item.id}}"><font-awesome-icon icon="print"/></v-btn>-->
          </template>

        </v-data-table>

        <!-- Pagination -->
          <div class="text-center pt-2">
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-col v-if="!$vuetify.breakpoint.xsOnly" class="d-flex" cols="12" sm="1">{{ $t("total") }} : {{ totalPage }}</v-col>
              <v-col class="d-flex" cols="12" sm="1" v-if="!$vuetify.breakpoint.xsOnly"><v-select :label="$t('perPage')" v-model="itemsPerPage" :items="pageList"></v-select></v-col>
              <v-pagination
                  v-model="currentPage"
                  :length="pageCount"
                  circle
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                  :total-visible="$vuetify.breakpoint.mobile ? 5 : 10"
              ></v-pagination>
              <v-col class="d-flex" cols="12" sm="1" v-if="!$vuetify.breakpoint.xsOnly">
                <v-text-field
                  v-model="currentPageComputed"
                  :max="pageCount"
                  min="1"
                  type="number"
                  :label="$t('goto')"
                ></v-text-field>
              </v-col>
            </v-card-actions>
          </div>
      </v-card>
    <!-- End Data table -->

    <!-- Form control -->
    <v-form v-model="valid" ref="formData">
      <v-dialog v-model="dialog" persistent fullscreen>
        <v-overlay :value="overlay"><v-progress-circular indeterminate size="64"></v-progress-circular></v-overlay>
        <v-card>
          <v-card-title class="dialog-header">
            <span class="headline" v-if="toggleAdd">{{ $t("addOrder") }}</span>
            <span class="headline" v-if="!toggleAdd">{{ $t("editOrder") }}</span>
            <v-spacer></v-spacer>
            <v-btn
                fab
                text
                icon
                @click="handleClose()"
                v-shortkey="['esc']"
                @shortkey.native="handleClose()"
            >
              <font-awesome-icon style="font-size: 20px;color: white" icon="times"/>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" sm="3" md="3" class="seperate-line-verticle">
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-autocomplete
                      v-model="formDoc.client_id"
                      :items="farmerOptionList"
                      outlined
                      :dense="dense"
                      auto-select-first
                      item-text="text"
                      item-value="id"
                      :label="$t('client') + '*'"
                      :rules="selectRules"
                      required
                      :search-input.sync="searchClient"
                      :disabled="isOrderLineHasData"
                    >
                      <template v-slot:selection="{ item }">{{ item.text }}</template>
                      <template v-slot:item="{ item }">{{ item.text }} : {{ item.mobile }}</template>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="12" md="12" v-if="userDoc.type === 'employee'">
                    <v-autocomplete
                        v-model="formDoc.supplier_id"
                        :items="supplierOptionList"
                        outlined
                        :dense="dense"
                        :disabled="isOrderLineHasData"
                        auto-select-first
                        item-text="text"
                        item-value="id"
                        :label="$t('supplier') + '*'"
                        :rules="selectRules"
                        required
                        :search-input.sync="searchSupplier"
                    >
                      <template v-slot:selection="{ item }">{{item.company_name ||   item.text }}</template>
                      <template v-slot:item="{ item }">{{item.company_name ||   item.text }} : {{ item.mobile }}</template>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-select
                        :items="currencyOptionList"
                        :label="$t('currency') + '*'"
                        outlined
                        v-model="formDoc.currency_code"
                        :rules="selectRules"
                        item-text="text"
                        item-value="id"
                        dense
                    >
                      <template v-slot:selection="{ item }">{{ item.text }}</template>
                    </v-select>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-select
                        :items="['credit', 'cash']"
                        :label="$t('priceType')"
                        outlined
                        v-model="formDoc.product_price_type"
                        :rules="requireRules"
                        item-text="text"
                        item-value="id"
                        dense
                        :disabled="isOrderLineHasData || formDoc.client_id == '10001100110000001'"
                    >
                        <template v-slot:selection="{item}">{{ $t(item) }}</template>
                        <template v-slot:item="{item}">{{ $t(item) }}</template>
                    </v-select>
                </v-col>

                <v-col cols="12" sm="12" md="12">
                    <v-select
                        :items="paymentMethod"
                        :label="$t('paymentMethod')"
                        outlined
                        v-model="formDoc.payment_method"
                        :rules="requireRules"
                        item-text="text"
                        item-value="id"
                        dense
                        :disabled="isOrderLineHasData || formDoc.client_id == '10001100110000001'"
                    >
                        <template v-slot:selection="{item}">{{ $t(item) }}</template>
                        <template v-slot:item="{item}">{{ $t(item) }}</template>
                    </v-select>
                </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-menu
                      v-model="menuDate"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          outlined
                          dense
                          v-model="formDoc.date"
                          :label="$t('orderDate') + '*'"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          :rules="dateRules"
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          :first-day-of-week="0"
                          v-model="formDoc.date"
                          :rules="dateRules"
                          @input="menuDate = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-menu
                        v-model="menuDate1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          outlined
                          dense
                          v-model="formDoc.expected_date"
                          :label="$t('expectedDate') + '*'"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          :rules="dateRules"
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          :first-day-of-week="0"
                          v-model="formDoc.expected_date"
                          :rules="dateRules"
                          @input="menuDate1 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      outlined
                      dense
                      v-model="formDoc.reference"
                      :label="$t('reference')"
                      :disabled="!toggleAdd"

                    ></v-text-field>
                  </v-col>

                </v-row>
              </v-col>

              <v-col cols="12" sm="9" md="9">
                <v-row>
                  <v-col cols="5" sm="4" md="4">
                    <v-autocomplete
                      v-model="filterDoc.category_id"
                      :items="categoryOptionList"
                      outlined
                      clearable
                      :dense="dense"
                      auto-select-first
                      item-text="text"
                      item-value="id"
                      :label="$t('category')"
                      :placeholder="$t('pleaseChooseCategory')"
                      required
                      :search-input.sync="searchCategory"
                    >
                    <template v-slot:selection="{ item }">{{ item.text }}</template>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="7" sm="8" md="8" v-if="formDoc.product_type==='product_group'">
                    <v-autocomplete
                      v-model="filterDoc.product_id"
                      :items="productList"
                      outlined
                      :dense="dense"
                      item-text="name"
                      item-value="id"
                      clearable
                      :disabled="isNotChooseSupplier"
                      :label="$t('product')"
                      :placeholder="$t('pleaseChooseProduct') + '*'"
                      required
                      :search-input.sync="searchProduct"
                    >
                      <template v-slot:selection="{ item }">{{ item.name }}</template>
                      <template v-slot:item="{ item }">{{ item.sku }} : {{ item.name}}</template>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="7" sm="8" md="8"  v-if="formDoc.product_type!=='product_group'">
                    <v-autocomplete
                        v-model="filterDoc.product_id"
                        :items="productList"
                        outlined
                        :dense="dense"
                        item-text="name"
                        item-value="variation_id"
                        clearable
                        :disabled="isNotChooseSupplier"
                        :label="$t('product')"
                        :placeholder="$t('pleaseChooseProduct') + '*'"
                        required
                        :search-input.sync="searchProduct"
                    >

                      <template v-slot:selection="{ item }">{{ item.name }}</template>
                      <template v-slot:item="{ item }">{{ item.sku }} : {{ item.name}}</template>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" md="12" sm="12">
                    <v-data-table
                      :headers="orderLineHeader"
                      :items="transaction_order_line"
                      hide-default-footer
                      mobile-breakpoint="0"
                    >
                      <template v-slot:header.name="{ header }">{{ $t(header.text) }}</template>
                      <template v-slot:header.order_qty="{ header }">{{ $t(header.text) }}</template>
                      <template v-slot:header.price="{ header }">{{ $t(header.text) }}</template>
                      <template v-slot:header.product_description="{ header }">{{ $t(header.text) }}</template>
                      <template v-slot:header.amount="{ header }">{{ $t(header.text) }}</template>
                      <template v-slot:header.action="{ header }">{{ $t(header.text) }}</template>
                      <template v-slot:item.order_qty="{ item }">
                        <v-text-field
                            style="min-width: 150px"
                            type="number"
                            v-model="item.order_qty"
                            @change.native="updateTransactionOrderLine(item)"
                            @keyup.native="updateTransactionOrderLine(item)"
                            hide-details="auto"
                            :suffix="item.unit_name"
                            dense
                        ></v-text-field>
                      </template>
                      <template v-slot:item.product_description="{ item }">
                        {{
                          item.product_description && item.product_description.substr(0, 9) || ""
                        }}{{ item.product_description && item.product_description.length > 9 ? "..." : "" }}
                      </template>
                      <template v-slot:item.price="{ item }">
                        {{ item.price | formatNumber }}{{ item.currency_symbol }}
                      </template>
                      <template v-slot:item.amount="{ item }">
                        {{ item.amount | formatNumber }}{{ item.currency_symbol }}
                      </template>

                      <template v-slot:item.action="{ item }">
                        <v-btn class="mx-2" rounded outlined fab dark x-small @click="handRemoveDetail(item)" color="error"><v-icon dark>mdi-minus</v-icon></v-btn>
                      </template>
                    </v-data-table>
                  </v-col>
                  <v-col sm="8" cols="2" style="text-align: right;"><h3>{{ $t("totalAmount") }} :</h3></v-col>
                  <v-col cols="10" sm="4" style="background-color: lightgray;font-weight: bold;font-size: 25px">{{ formDoc.total_amount | formatNumber }}{{ currency_symbol }}</v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-textarea
                        clearable
                        v-model="formDoc.note"
                        clear-icon="mdi-close-circle"
                        rows="4"
                        outlined
                        :placeholder="$t('yourDesc')"
                        auto-grow
                        :label="$t('note')"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="reset">RESET</v-btn>
            <v-btn rounded @click="submit($event)" style="min-width: 150px" color="success"><font-awesome-icon icon="check-circle" class="mr-2"/>{{ $t('save') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>

    <v-bottom-sheet v-model="sheet">
      <v-sheet class="text-center" height="200px">
        <v-btn class="mt-6" text color="red" @click="sheet = !sheet">{{ $t('close') }}</v-btn>
        <div class="py-3">
          <v-btn class="mt-6 mr-6" rounded text outlined color="green" @click="sheet = !sheet,handleAdd('agri-input_and_rice')">{{ $t('productItem') }}</v-btn>
          <v-btn class="mt-6" rounded text outlined color="teal" @click="sheet = !sheet,handleAdd('product_group')">{{ $t('productPackage') }}</v-btn>
        </div>
        <div class="py-3">{{ $t('pleaseChooseProductType') }}</div>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>

<script>
import MainMixin from "../../../mixins/mainMixin";
import ValidatorMixin from "../../../mixins/validatorMixin";
import OptionDataMixin from "../../../mixins/optionDataMixin";
import moment from "moment"; 
import {provider} from "@/service/provider";
import axios from "axios";
import _ from "lodash";

export default {
  name: "orderFarmer",
  mixins: [MainMixin, ValidatorMixin, OptionDataMixin],
  data() {
    return {
      sheet: false,
      formDoc: {
        id: "",
        business_id: "",
        supplier_id: "",
        client_id: "",
        date: moment().format("YYYY-MM-DD"),
        reference: "",
        expected_date: moment().format("YYYY-MM-DD"),
        status: "order",
        total_amount: 0,
        currency_code: "",
        note: "",
        user_id: "",
        payment_method: "cash",
        product_price_type: '',
        product_type: ""

      },
      filterDoc: {
        product_id: "",
        category_id: ""
      },
      headers: [
        {
          text: "orderDate",
          align: "start",
          value: "date"
        }, {
          text: "expectedDate",
          align: "start",
          value: "expected_date"
        },
        {text: "reference", value: "reference"},
        {text: "clientName", value: "client_name", sortable: false},
        {text: "supplierName", value: "supplier_name", sortable: false},
        {text: "totalAmount", value: "total_amount"},
        {text: "status", value: "status"},
        {text: "action", value: "action", sortable: false, width: 150}
      ],
      transaction_order_line: [],
      orderLineHeader: [
        {
          text: "productName",
          align: "start",
          sortable: false,
          value: "name"
        },
        {text: "qty", value: "order_qty", width: 150, sortable: false},
        {text: "price", value: "price", sortable: false},
        {text: "amount", value: "amount", sortable: false},
        {text: "note", value: "product_description"},
        {text: "action", value: "action", width: 50, sortable: false}
      ],
      searchSupplier: "",
      searchProduct: "",
      searchCategory: "",
      searchClient: "",
      currency_symbol: "",

      supplierDoc: {},
      client_type: "",
      parent_id: "",
    };
  },
  methods: {
    reset() {
      if (this.$refs.formData) {
        this.$refs.formData.reset();
        this.transaction_order_line = [];
        this.calculateTotal();
      }
    },
    handleAdd(productType) {
      let vm = this;
      vm.reset();
      vm.dialog = true;
      vm.toggleAdd = true;
      vm.formDoc.id = "";
      vm.formDoc.supplier_id = localStorage.contact_id;
      vm.formDoc.date = moment().format("YYYY-MM-DD");
      vm.formDoc.expected_date = moment().format("YYYY-MM-DD");
      vm.formDoc.product_type = productType;
    },
    handleClose() {
      this.dialog = false;
      this.reset();
    },
    fetchDataTable: _.debounce(function () {
      let vm = this;
      vm.fetchTransactionProductOrder({
        search: vm.search,
        id: "",
        offset: vm.currentPage,
        limit: vm.itemsPerPage,
        sortBy: vm.options.sortBy[0] || "created_at",
        sortDesc: vm.options.sortDesc[0]===false ? 0 :1,
        from_date: vm.from_date,
        to_date: vm.to_date,
      })
    }, 350),
    handleRemove(item) {
      let vm = this;
      vm.$confirm(vm.$t("thisWillDelete") + item.id + ' . ' + vm.$t('continue') + '?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        vm.removeTransactionOrder(item.id);

      }).catch(() => {
        vm.$message({
          type: 'info',
          message: vm.$t('deleteCancel')
        });
      });
    },
    handleEdit(item, event) {
      event.preventDefault();
      let vm = this;
      vm.formDoc = {};
      vm.overlay = true;
      vm.toggleAdd = false;

      let url = provider.baseURL + "/get_list_transaction_product_order";
      return new Promise((resolve, reject) => {
        axios.post(url, {
          search: "",
          id: item.id,
          offset: 0,
          type_order: "",
          sort_by: "",
          sort_desc: 0,
          limit: 1
        }, {headers: {Authorization: localStorage.token}}).then(
            res => {
              if (res.data.response && res.data.response.code === 200) {
                vm.overlay = false;
                vm.dialog = true;
                resolve(res.data.data);
                let newItem = res.data.data[0];

                vm.filterDoc.category_id = "";
                vm.filterDoc.product_id = "";
                vm.formDoc = Object.assign({}, newItem);

                vm.formDoc.total_amount = parseFloat(vm.formDoc.total_amount);
                vm.formDoc.date = vm.parseFromDate(vm.formDoc.date);
                vm.formDoc.expected_date = vm.parseFromDate(vm.formDoc.expected_date);
                vm.transaction_order_line = [];
                vm.transaction_order_line.push(...newItem.transaction_order_line);

                vm.transaction_order_line.map((d) => {
                  d.currency_code = vm.formDoc.currency_code;
                  d.currency_symbol = vm.getCurrencySymbol(vm.formDoc.currency_code);
                  d.order_qty = parseFloat(d.order_qty);
                  d.price = parseFloat(d.price);
                  d.amount = parseFloat(d.amount);
                  return d;
                })
              }
            },
            error => {
              reject(error);
            }
        );
      });


    },
    submit(event) {
      event.preventDefault();
      let vm = this;
      if (vm.$refs.formData.validate()) {
        if(vm.transaction_order_line.filter(obj => { return obj.order_qty > 0 }).length){
          vm.overlay=true;
          vm.formDoc.user_id = localStorage.id;
          vm.transaction_order_line.map((d) => {
            d.order_qty = parseFloat(d.order_qty);
            d.price = parseFloat(d.price);
            d.amount = parseFloat(d.amount);
            return d;
          })
          
          vm.formDoc.note = vm.formDoc.note || "";
          vm.formDoc.transaction_order_line = vm.transaction_order_line;
          let newFormDoc = Object.assign({}, vm.formDoc);
          newFormDoc.date = vm.parseToDate(vm.formDoc.date);
          newFormDoc.expected_date = vm.parseToDate(vm.formDoc.expected_date);
          let url = provider.baseURL + "/store_transaction_product_order";
          return new Promise((resolve, reject) => {
            axios.post(url, newFormDoc, {headers: {Authorization: localStorage.token}}).then(
                res => {
                  if (res.data.response && res.data.response.code === 200) {
                    resolve(res.data.transaction_order_id);
                    vm.$notify({
                      title: "Success",
                      message: vm.$t("success"),
                      type: "success",
                      duration: 700
                    });
                    vm.dialog = false;
                    vm.fetchDataTable();


                  }
                  vm.overlay=false;
                },
                error => {
                  reject(error);
                  vm.overlay=false;

                }
            );
          });
        }
        else {
          vm.$notify({
              title: "Error",
              message: vm.$t("pleaseCheckProductOrder"),
              type: "error",
              duration: 2000
          });  
        }
      }
  
    },
    handleChooseProductType() {
      let vm = this;
      vm.sheet = true;
    },
    handRemoveDetail(item) {
      let vm = this;
      vm.$confirm(vm.$t("thisWillDelete") + item.name + ' . ' + vm.$t('continue') + '?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {

        vm.removeTransactionOrderLine(item);
        vm.$message({
          type: 'success',
          message: vm.$t('deleteComplete')
        });
      }).catch(() => {
        vm.$message({
          type: 'info',
          message: vm.$t('deleteCancel')
        });
      });
    },
    removeTransactionOrder(id) {
      let vm = this;
      let url = provider.baseURL + "/remove_transaction_order";
      return new Promise((resolve, reject) => {
        axios.post(url, {id: id}, {headers: {Authorization: localStorage.token}}).then(
            res => {
              if (res.data.response && res.data.response.code === 200) {
                resolve(res.data.data);
                vm.$message({
                  type: 'success',
                  message: vm.$t('deleteComplete')
                });
                vm.fetchDataTable();
              }
            },
            error => {
              reject(error);
            }
        );
      });
    },
    removeTransactionOrderLine(row) {
      let vm = this;
      let index = vm.transaction_order_line.findIndex(
          ind => ind.product_id === row.product_id
      );
      vm.transaction_order_line.splice(index, 1);
      vm.calculateTotal();

    },
    updateTransactionOrderLine(row) {
      //When we update order line by change qty
      let vm = this;
      let newDoc = row;
      let index = vm.transaction_order_line.findIndex(
          ind => ind.product_id === row.product_id
      );

      newDoc.order_qty = +newDoc.order_qty;
      newDoc.price = vm.convertExchangeRate(row.currency_code, vm.formDoc.currency_code, parseFloat(row.price || 0));
      newDoc.currency_code = vm.formDoc.currency_code;
      newDoc.currency_symbol = vm.getCurrencySymbol(vm.formDoc.currency_code);
      newDoc.amount = newDoc.order_qty * parseFloat(newDoc.price);
      vm.transaction_order_line[index] = newDoc;

      vm.$nextTick(() => {
        vm.calculateTotal();

        vm.filterDoc.product_id = "";
        vm.searchProduct = "";
      });
    },
    
    addToTransactionOrderLine(val) {
      let vm = this;
      if (val) {
        if (vm.formDoc.product_type!== "product_group") {
          let productDoc = vm.productList.find(obj => obj.variation_id === val);
          //Check condition choose price up to depo , shop ,farmer
          let price = 0;
          price = vm.convertExchangeRate(productDoc.currency_code, vm.formDoc.currency_code, parseFloat(productDoc.price || 0));
          //Check product already choose
          let checkExist = vm.transaction_order_line.find(od => od.variation_id === val);
          if (checkExist) {
            let current_qty = parseFloat(checkExist.order_qty);
            checkExist.order_qty =  current_qty + 1;
            vm.updateTransactionOrderLine(checkExist);
          } else {

            //Add new product to order
            if (productDoc) {
                vm.transaction_order_line.push({
                    transaction_order_line_id: "",
                    product_group_item_variation_id: "",
                    product_group_item_id: "",
                    product_id: productDoc.id,
                    variation_id: productDoc.variation_id,
                    name: productDoc.name,
                    order_qty: 1,
                    currency_code: vm.formDoc.currency_code,
                    currency_symbol: vm.getCurrencySymbol(vm.formDoc.currency_code),
                    unit_name: productDoc.unit_name,
                    unit_id: parseInt(productDoc.unit_id),
                    price: price,
                    amount: price,
                    product_description: productDoc.product_description || ""
                  });
                  vm.$notify({
                    title: "Success",
                    message: vm.$t("addProductSuccess"),
                    type: "success",
                    duration: 700
                  });
            } else {
              vm.$notify({
                title: "Error",
                message: vm.$t("canNotFind"),
                type: "error",
                duration: 700
              });
            }
            vm.$nextTick(() => {
              vm.calculateTotal();
              vm.filterDoc.product_id = "";
              vm.searchProduct = "";
            });
          }
        }else {
          //Check condition choose price up to depo , shop ,farmer
          let productDoc = vm.productList.find(obj => obj.id === val);
          let price = 0;
          price = vm.convertExchangeRate(productDoc.currency_code, vm.formDoc.currency_code, parseFloat(productDoc.price || 0));
          //Check product already choose
          let checkExist = vm.transaction_order_line.find(od => od.product_id === val);
          if (checkExist) {

            //Update product to increase qty
            checkExist.order_qty = parseFloat(checkExist.order_qty) + 1;
            vm.updateTransactionOrderLine(checkExist);
          } else {

            //Add new product to order
            if (productDoc) {
              vm.transaction_order_line.push({
                transaction_order_line_id: "",
                product_group_item_variation_id: "",
                product_group_item_id: "",
                product_id: productDoc.id,
                variation_id: productDoc.variation_id || "",
                name: productDoc.name,
                order_qty: 1,
                currency_code: vm.formDoc.currency_code,
                currency_symbol: vm.getCurrencySymbol(vm.formDoc.currency_code),
                unit_name: productDoc.unit_name,
                unit_id: parseInt(productDoc.unit_id),
                price: price,
                amount: price,
                product_description: productDoc.product_description || ""
              });
              vm.$notify({
                title: "Success",
                message: vm.$t("addProductSuccess"),
                type: "success",
                duration: 700
              });
            } else {
              vm.$notify({
                title: "Error",
                message: vm.$t("canNotFind"),
                type: "error",
                duration: 700
              });
            }
            vm.$nextTick(() => {
              vm.calculateTotal();
              vm.filterDoc.product_id = "";
              vm.searchProduct = "";
            });
          }
        }

      }
    },

    calculateTotal() {
      let vm = this;
      vm.formDoc.total_amount = 0;
      vm.transaction_order_line.forEach((obj) => {
        vm.formDoc.total_amount += parseFloat(obj.amount);
      })
    },
    handleFetchProduct() {
      let vm = this;
      if (vm.formDoc.supplier_id && vm.formDoc.client_id && vm.formDoc.currency_code && vm.formDoc.product_price_type, vm.formDoc.currency_code) {
        if (vm.formDoc.product_type === "product_group") {
          vm.fetchProductPackage(vm.searchProduct, vm.filterDoc.category_id, vm.formDoc.product_price_type);
        } else {
          vm.fetchProductFarmer(vm.searchProduct, vm.filterDoc.category_id, vm.formDoc.supplier_id, vm.formDoc.currency_code, vm.supplierDoc && vm.supplierDoc.supplier_type || "", vm.formDoc.product_price_type);
        }
      }
    },

    handleSearch(){
        this.fetchDataTable();
    }
  },
  computed: {
    userDoc() {
      return this.$store.state.userDoc;
    },
    isNotChooseSupplier() {
      return !(this.formDoc.supplier_id && this.formDoc.currency_code);
    },
    isOrderLineHasData() {
      return !!this.transaction_order_line.length;
    }
  },
  watch: {
    searchSupplier(val) {
      let vm = this;
      val && vm.fetchSupplierOption(val, vm.client_type, vm.parent_id);
    },
    searchClient(val) {
      let vm = this;
      val && vm.fetchClientOption(val);
    },
    "filterDoc.category_id"() {
      let vm = this;
      vm.handleFetchProduct();
    },
    searchProduct(val) {
      let vm = this;
      val && vm.handleFetchProduct();
    },
    "filterDoc.product_id"(val) {
      let vm = this;
      vm.addToTransactionOrderLine(val);
    },
    "formDoc.currency_code"(val) {
      let vm = this;
      vm.transaction_order_line.forEach((d) => {
        vm.updateTransactionOrderLine(d);
      });

      vm.currency_symbol = vm.getCurrencySymbol(val);
      vm.handleFetchProduct();
    },
    "formDoc.supplier_id"(val) {
      let vm = this;
      vm.supplierDoc = vm.supplierOptionList.find(obj => obj.id === val);
      vm.handleFetchProduct();
      vm.fetchCategoryOption(val);


    },
    "formDoc.client_id"(val) {
      let vm = this;
      let clientDoc = vm.farmerOptionList.find(obj => obj.id === val + "");
      vm.client_type = clientDoc && clientDoc.type || "";
      vm.parent_id = clientDoc && clientDoc.parent_id || "";
      vm.fetchSupplierOption("", vm.client_type, vm.parent_id);
      vm.handleFetchProduct();
      if(val == '10001100110000001'){
          this.formDoc.product_price_type = 'cash';
      }
    },
   
    currentPage() {
      this.loading = true;
      this.fetchDataTable();
    },
    itemsPerPage() {
      this.loading = true;
      this.fetchDataTable();
    },
    "formDoc.payment_method"() {
      this.handleFetchProduct();
    },

    "formDoc.product_price_type"(val){
        if(val){
            this.handleFetchProduct();
        }
    },
  },
  created() {
    let vm = this;
    vm.fetchFarmerOption();
    //vm.fetchSupplierOption();
    vm.fetchCurrencyOption();
  }
};
</script>
